import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Topic } from './forum/topic';
import { TopicService } from './topic.service';

@Injectable()
export class TopicPostResolver {
  private topic = inject(TopicService);

  resolve(route: ActivatedRouteSnapshot): Observable<Topic> {
    const forumId = route.paramMap.get('id');
    return this.topic.getTopic(forumId);
  }
}
